import React, { useState, useRef } from 'react';
import {
  Avatar,
  Box,
  ButtonBase,
  makeStyles,
  MenuItem,
  Menu,
  ListItemIcon,
  Typography,
  Link,
  Divider
} from '@material-ui/core';
import { useAuth0 } from '@auth0/auth0-react';
import { Link as RouterLink } from 'react-router-dom';

import useUser from 'src/hooks/useUser';
import { basename } from 'src/config';

const useStyles = makeStyles((theme) => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1)
  },
  menuAvatar: {
    height: 40,
    width: 40,
    marginRight: theme.spacing(1)
  }
}));

const Account = () => {
  const classes = useStyles();
  const { user } = useUser();
  const { logout } = useAuth0();
  const ref = useRef(null);
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  /**
   * ingressが /bois/* でのアクセスを期待するため、redirectUriにトレイリングスラッシュを入れること
   * トレイリングスラッシュがない場合、Auth0からのコールバック時に無限ループが発生する
   */
  const handleLogout = () => logout({ returnTo: `${window.location.origin}${basename}/` });

  return (
    <>
      <Box component={ButtonBase} onClick={handleOpen} ref={ref}>
        <Avatar alt="User" className={classes.avatar} src={user.picture} />
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{ vertical: 40, horizontal: 'center' }}
        keepMounted // なぜこれが必要かは不明だがMaterial-UIのexampleでは使用している
        getContentAnchorEl={null} // これがないとTopBarの下にメニューが表示されない (https://stackoverflow.com/questions/48157863/how-to-make-a-dropdown-menu-open-below-the-appbar-using-material-ui)
        anchorEl={ref.current}
        open={isOpen}
      >
        <MenuItem>
          <ListItemIcon>
            <Avatar alt="User" className={classes.menuAvatar} src={user.picture} />
          </ListItemIcon>
          <div>
            <Typography variant="h6" noWrap>
              {user.email}
            </Typography>
          </div>
        </MenuItem>
        <MenuItem dense component={RouterLink} to={'/profile/edit'}>
          <Typography variant="h5">個人設定</Typography>
        </MenuItem>
        <MenuItem
          dense
          component={Link}
          href="https://www.bois.bbtower.co.jp/docs/customer/"
          target="_blank"
          color="inherit"
        >
          <Typography variant="h5">ご利用ガイド</Typography>
        </MenuItem>
        <Box pt={1} pb={1}>
          <Divider />
        </Box>
        <MenuItem dense onClick={handleLogout}>
          <Typography variant="h5">ログアウト</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default Account;
